import React, { useState, useEffect } from "react";
import axios from "axios";
import ButtonPrimary from "../components/Button-primary";

const Transactions = () => {
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [showClearButton, setShowClearButton] = useState(false);
  const [showTxHash, setShowTxHash] = useState(true);
  const [transactionHash, setTransactionHash] = useState("");

  console.log(transactionHash);

  // *********** Get the hash of the transaction link *************

  // const getHash = (event) => {
  //   if (event.target.name === "transactionHash") {
  //     const hash = event.target.value.split("/").pop();
  //     setTransactionHash(hash);
  //   }
  // };

  function toggleUnitPriceView(showTxHash) {
    setShowTxHash(showTxHash);
  }

  const calculateUnitPrice = () => {
    if (price === "" || quantity === "") {
      return "Please enter a price and quantity";
    }
    const unitPrice = price / quantity;
    return `Unit Price : $${unitPrice.toFixed(4)}`;
  };

  const handleInputChange = (event) => {
    if (event.target.name === "price") {
      setPrice(event.target.value);
    } else {
      setQuantity(event.target.value);
    }
    setShowClearButton(event.target.value !== "");
  };

  const clearInputs = () => {
    setPrice("");
    setQuantity("");
    setShowClearButton(false);
  };


  const [txInfos, seTxInfos] = useState({});

  const fetchData = async () => {
    const response = await axios.get(
      `https://tx.eth.samczsun.com/api/v1/trace/binance/0x65c3c075e5a419ce72005e9a872a80a00ce39adb0f2bb87794a53727e0af8fe0`
    );
    seTxInfos(response.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const get5thAddress = (data) => {
    if (!data) return null;
    const addresses = Object.values(data);
    return addresses[4];
  };

  const get7thAddress = (data) => {
    if (!data) return null;
    const addresses = Object.values(data);
    return addresses[6];
  };

  const addressesArray = txInfos?.result?.addresses

  const fourthAddress = get5thAddress(addressesArray);
  const sixthAddress = get7thAddress(addressesArray);

  const getTokenToSwap = (data) => {
    if (!data) return null;
    const amount = Object.values(data);
    return amount
  };

  const tickerToSwap = getTokenToSwap(fourthAddress);
  const tickerSwapped = getTokenToSwap(sixthAddress);


  console.log("txInfos ", txInfos);
  console.log("TickerToSwap ", tickerToSwap ? tickerToSwap[0]?.label : null);
  console.log("TickerSwapped ", tickerSwapped ? tickerSwapped[0]?.label : null);

  // const txToken = txInfos?.result;

  // const amount = txToken.entrypoint?.children[4].data

  // if (txToken && Object.keys(txToken.addresses).length > 0) {
  //   const firstKey = Object.keys(txToken.addresses)[0];
  //   const secondKey = Object.keys(txToken.addresses[firstKey])[0];
  //   const label = txToken.addresses[firstKey]?.[secondKey]?.label;

  
  //   console.log("txToken ", label);
  //   console.log("Amount ", amount);
  // } else {
  //   console.log("txToken is not available or doesn't have the required structure.");
  // }

  // const hexToDecimal = (amount) => {

  //   const cleanHexValue = amount.slice(-32);

  //   // Convert the clean hexadecimal value to decimal
  //   const decimalValue = parseInt(cleanHexValue, 16);

  //   return decimalValue;
  // };

  // const decimalValue = hexToDecimal(amount);

  // console.log("decimalValue ", decimalValue/1000000000000000000);


  // 0xb31e9426763274a6ec335f99f3393ac0b8cd0a140d6b88abb4d003b2e42c202d


  return (
    <div>
      <div className="flex flex-col w-10/12 border border-gray-200 p-4 mt-5 space-y-4 m-auto bg-gray-50 rounded-lg sm:w-1/3">
        <h1 className="m-auto text-xl font-bold">Unit Price Calculator</h1>
        <div className="flex flex-row justify-around flex-wrap gap-4 md:gap-0">
          <ButtonPrimary text={"By Tx Hash"} func={() => toggleUnitPriceView(true)} className={`${showTxHash ? "bg-blue-600" : "bg-blue-400"}`} />
          <ButtonPrimary text={"By Quantity"} func={() => toggleUnitPriceView(false)} className={!showTxHash ? "bg-blue-600" : "bg-blue-400"} />
        </div>
      </div>

      <div>

      <div className="relative">
        <div
          id="unitPriceTxHash"
          className={`flex flex-col w-10/12 border border-gray-200 p-4 mt-5 space-y-4 m-auto bg-gray-50 rounded-lg sm:w-1/3 ${
            !showTxHash ? "hidden" : ""
          }`}
        >
          <label>Transaction hash</label>
          <input
            type="link"
            name="transactionHash"
            className="p-2 rounded-lg mt-1"
            value={transactionHash}
            onChange={(e) => setTransactionHash(e.target.value)}
          />
          <br />
          <p className="m-auto text-xl font-bold">{calculateUnitPrice()}</p>
        </div>
        <div className={`absolute inset-0 bg-gray-50 bg-opacity-50 flex items-center justify-center backdrop-filter backdrop-blur-lg w-10/12 md:w-1/3 m-auto mt-0 rounded-lg ${
            !showTxHash ? "hidden" : ""
          }`}>
          <p className="text-3xl font-bold text-gray-700">Coming Soon</p>
        </div>
        </div>
      </div>
      <div
        id="unitPriceQuantity"
        className={`flex flex-col w-10/12 border border-gray-200 p-4 mt-5 space-y-4 m-auto bg-gray-50 rounded-lg sm:w-1/3 ${
          showTxHash ? "hidden" : ""
        }`}
      >
        <label>Price: </label>
        <input
          type="number"
          name="price"
          value={price}
          onChange={handleInputChange}
          className="p-2 rounded-lg mt-1"
        />
        <br />
        <label>Quantity: </label>
        <input
          type="number"
          value={quantity}
          onChange={handleInputChange}
          className="p-2 rounded-lg mt-1"
        />
        <br />
        {showClearButton && (
          <ButtonPrimary text={"Clear"} func={clearInputs} className={"bg-red-400 w-4/12 rounded-lg m-auto text-white font-medium text-lg hover:bg-red-600 transition"} />
        )}
        <br />
        <p className="m-auto text-xl font-bold">{calculateUnitPrice()}</p>
      </div>
    </div>
  );
};

export default Transactions;
